/* eslint-disable import/prefer-default-export */

import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

// import AntdIcon from 'antd/lib/icon';
import {
  UploadOutlined,
} from '@ant-design/icons';

import { Redirect } from 'react-router-dom';

import Admin from '../../components/Admin';
import tests from '../../helpers/tests';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const getDashedBackgroundSrc = ({
  color = 'black',
  radius = 0,
  width = 2,
  dashArray1 = 6,
  dashArray2,
} = {}) => {
  radius = parseInt(radius, 10);
  width = parseInt(width, 10);
  dashArray1 = parseInt(dashArray1, 10);
  dashArray2 = (
    typeof dashArray2 === 'undefined'
    ? Math.round(dashArray1 * 1.3)
    : parseInt(dashArray2, 10)
  );
  // eslint-disable-next-line max-len
  return `data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='${
    radius
  }' ry='${
    radius
  }' stroke='${
    encodeURIComponent(color)
  }' stroke-width='${
    width
  }' stroke-dasharray='${
    dashArray1
  }%2c ${
    dashArray2
  }' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e`;
};

// eslint-disable-next-line max-len
const UploadArea = styled.label`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100px;
  border-radius: ${({ theme }) => theme.less.borderRadius};
  /* border: 1px dashed ${({ theme }) => theme.less.borderColor}; */
  background-image: ${({ theme }) => `url("${getDashedBackgroundSrc({
    color: theme.less.borderColor,
    radius: theme.less.borderRadius,
  })}")`};
  cursor: pointer;
  ${({ $disabled }) => (
    $disabled
    ? css`
        pointer-events: none !important;
        * {
          pointer-events: none !important;
        }
        > * {
          opacity: 0.5;
        }
      `
    : css`
        color: ${({ theme }) => theme.less.primaryColor};
      `
  )}
`;

const UploadAreaIcon = styled(UploadOutlined)`
  svg {
    opacity: 0.7;
    font-size: 40px;
  }
`;

const UploadAreaText = styled.p`
  margin: 0px;
  margin-top: 5px;
`;

const UploadInput = styled.input`
  opacity: 0;
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  cursor: pointer;
`;

function Upload({ client, ready, companyId }) {
  const [file, setFile] = useState(null);
  const [importId, setImportId] = useState(null);
  useEffect(
    () => {
      let cancelled = false;
      if (file && companyId) {
        const form = new FormData();
        form.set('file', file, 'import.csv');
        client.request({
          url: `orders/shipping-company-import?company=${
            companyId
          }&ready=${!!ready}`,
          method: 'POST',
          data: form,
        })
        .then(async (response) => {
          if (!cancelled && response?.data?._id) {
            await new Promise(resolve => setTimeout(resolve, 500));
            Admin.showMessage(
              'CSV Uploaded and will be processed shortly',
              'success',
              3,
            );
            setImportId(response.data._id);
            // setValue('');
          }
          setFile(null);
        })
        .catch(async (error) => {
          if (!cancelled) {
            await new Promise(resolve => setTimeout(resolve, 500));
            error.message = error.response?.data?.message || error?.message;
            Admin.showMessage(
              `CSV Upload Failed: ${error.message}`,
              'error',
              5,
            );
            // setValue('');
            setFile(null);
          }
          console.log(error); // eslint-disable-line no-console
        });
      }
      return () => {
        cancelled = true;
      };
    },
    [ready, companyId, file, setFile, client],
  );
  return (
    <UploadArea $disabled={!companyId}>
      {
        importId
        ? <Redirect to={`/shipping/imports/${importId}`} />
        : null
      }
      <UploadAreaIcon />
      <UploadAreaText>
        {
            companyId
          ? 'Drag and drop the csv file or click to select'
          : 'First select the Shipping Company you\'re importing'
        }
      </UploadAreaText>
      <UploadInput
        type="file"
        accept="text/csv"
        value=""
        onChange={async (ev) => {
          if (companyId) {
            const { target: { files } } = ev;
            if (files && files[0]) {
              setFile(files[0]);
            } else {
              setFile(null);
            }
          }
        }}
      />
    </UploadArea>
  );
}

export const filterShippingCompanyImport = ['FilterField', {
  id: 'shipping-company-import',
  name: 'shipping-company-import',
  label: null,
  section: 'top',
  buildQuery: () => {},
  propsFromPage: ({ client, viewer }) => ({ client, viewer }),
  field: ['ActionWithFormModal', {
    name: 'shipping-company-import',
    label: null,
    title: 'Shipping Company Import',
    icon: 'upload',
    type: 'default',
    style: { width: '100%' },
    // eslint-disable-next-line arrow-body-style, no-unused-vars
    canToggleModalOpen: (props, action, newVisible) => {
      // return newVisible === true;
      return true;
    },
    modalProps: {
      centered: true,
      closable: true,
      footer: false,
    },
    skip: [tests.viewerIsAdminAndDoesNotHavePermission('shippingImportExport')],
    fields: [
      ['FieldConnectionSelect', {
        name: 'company',
        label: null,
        // prefix: 'Shipping Company:',
        url: '/shippingcompanies',
        placeholder: 'Choose the Shipping Company being imported',
        allowClear: true,
        searchPaths: ['name'],
      }],
      ['FieldReact', {
        name: 'upload',
        label: null,
        ContentComponent: (props) => (
          <Wrapper>
            <Upload
              client={props.client}
              companyId={props.form.getFieldValue('company')}
              ready={false}
            />
          </Wrapper>
        ),
      }],
    ],
    actions: [],
  }],
}];
